// SPV Pool v1.0 PR 9 — typed transport for /api/capital-markets/dashboard/*.
// Read-only aggregation behind the cross-pool dashboard.

import { api } from "./client";
import type {
  AggregateConcentrationDto,
  PoolInFlightDto,
  TopKpisDto,
  UpcomingEventDto,
} from "@/types/capitalMarketsDashboard";

export const capitalMarketsDashboardApi = {
  topKpis: () =>
    api.get<TopKpisDto>("/capital-markets/dashboard/top-kpis"),
  poolsInFlight: () =>
    api.get<PoolInFlightDto[]>("/capital-markets/dashboard/pools-in-flight"),
  upcomingEvents: (daysAhead: number) =>
    api.get<UpcomingEventDto[]>("/capital-markets/dashboard/upcoming-events", {
      daysAhead,
    }),
  aggregateConcentration: () =>
    api.get<AggregateConcentrationDto>(
      "/capital-markets/dashboard/aggregate-concentration",
    ),
};
